module.exports = __webpack_public_path__ + "img/technology.eb76e17e.png";